export function handlePopupFormSubmit(form) {
    var submitBtn = form.find('button[type="submit"]');
    submitBtn.prop('disabled', true);
    var url = form.attr('action');
    $.ajax({
        type: 'POST',
        url: url,
        data: form.serialize(),
    }).done(function (response) { return handleAjaxResponse(form, response); }).fail(function (response) { return handleAjaxResponse(form, response); });
}
function handleAjaxResponse(form, response) {
    form.find('button[type="submit"]').prop('disabled', false);
    if (response.message) {
        form.find('.ts-error-message').text(response.message).removeClass('hidden');
    }
    else if (response.redirect) {
        document.location.href = response.redirect;
    }
    else {
        document.location.reload();
    }
}
